import WebSocket from 'ws';
import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import { safeSendWebSocketBinary } from '../../connection/cli-ws-client.js';
import { proxyToLocalStreaming } from './proxy-to-local-streaming.js';
import type { LogFn } from '../../log.js';

export interface StreamingProxyRequest {
  id: string;
  method: string;
  url: string;
  headers?: Record<string, string>;
  body?: string | Uint8Array;
  streamResponse: boolean;
}

/**
 * Forward a streaming preview request to localhost and pipe the response back on the firehose WebSocket.
 */
export function startStreamingProxy(ws: WebSocket, log: LogFn, pr: StreamingProxyRequest): void {
  proxyToLocalStreaming(pr, {
    onStart: (statusCode, headers) => {
      if (ws.readyState !== WebSocket.OPEN) {
        throw new Error('Preview stream interrupted (firehose connection closed)');
      }
      sendWsMessage(ws, { type: 'proxy_result_start', id: pr.id, statusCode, headers });
    },
    onChunk: (chunk) => {
      const idBuf = Buffer.from(pr.id, 'utf8');
      const buf = Buffer.concat([idBuf, Buffer.from(chunk)]);
      if (!safeSendWebSocketBinary(ws, buf)) {
        throw new Error('Preview stream interrupted (firehose connection closed)');
      }
    },
    onEnd: () => sendWsMessage(ws, { type: 'proxy_result_end', id: pr.id }),
    onError: (error) => {
      log(`[Proxy and log service] Streaming preview failed: ${error}`);
      sendWsMessage(ws, { type: 'proxy_result_error', id: pr.id, error });
    },
  });
}
